export type TDealNetworkRecommendationFilter =
  | { type: "all" }
  | { type: "categories"; categoryIds: string[] }
  | { type: "shortlisted" }
  | { type: "dismissed" };

export const DEFAULT_DEAL_NETWORK_RECOMMENDATION_FILTER: TDealNetworkRecommendationFilter = {
  type: "all",
};
